module.exports = __webpack_public_path__ + "img/sem-imagem.aa5957bb.jpg";